// extracted by mini-css-extract-plugin
export default {"main":"Offer_main__0ZPfV","smallTitle":"Offer_smallTitle__2Pyqb","descRight":"Offer_descRight__nEgKg"};